import { render, staticRenderFns } from "./Wait.vue?vue&type=template&id=f1193d1a&scoped=true&"
import script from "./Wait.vue?vue&type=script&lang=js&"
export * from "./Wait.vue?vue&type=script&lang=js&"
import style0 from "./Wait.vue?vue&type=style&index=0&id=f1193d1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1193d1a",
  null
  
)

component.options.__file = "Wait.vue"
export default component.exports